module.exports = __webpack_public_path__ + "static/media/yellow-star.2988a0e5.png";